export const GET = "GET";
export const SETLIST = "SETLIST";
export const SETDOCUMENTLIST = "SETDOCUMENTLIST";
export const SETCUSTOMERLIST = "SETCUSTOMERLIST";
export const SETITEMLIST = "SETITEMLIST";
export const SETITEMMODALVISIBLE = "SETITEMMODALVISIBLE";
export const SETITEMS = "SETITEMS";
export const SETQUOTECUSTOMERLIST = "SETQUOTECUSTOMERLIST";
export const SETTAXLIST = "SETTAXLIST";
export const SETFLEXIQUOTE = "SETFLEXIQUOTE";
export const CLEARDOC = "CLEARDOC";
export const SETCURRENCYLIST = "SETCURRENCYLIST";
export const SETFLEXIQUOTEBASICFILTERDATA = "SETFLEXIQUOTEBASICFILTERDATA";
export const SETFLEXIQUOTELIST = "SETFLEXIQUOTELIST";
export const SETFLEXIQUOTELISTBYID = "SETFLEXIQUOTELISTBYID";
export const SETFLEXIQUOTESTATUS = "SETFLEXIQUOTESTATUS";
export const SETFLEXIQUOTESTATUSCOUNT = "SETFLEXIQUOTESTATUSCOUNT";
export const SETBPMASTERADDRESS = "SETBPMASTERADDRESS";
export const SETFLEXIQUOTECATEGORY = "SETFLEXIQUOTECATEGORY";
export const SETFLEXIQUOTEITEMLISTING = "SETFLEXIQUOTEITEMLISTING";
export const SETFLEXIQUOTEPRICE = "SETFLEXIQUOTEPRICE";
export const SETTAXCODE = "SETTAXCODE";
export const SETFLEXIATTACHMENTDATA = "SETFLEXIATTACHMENTDATA";
export const SETPRICELIST = "SETPRICELIST";
export const SETBASEIMAGE = "SETBASEIMAGE";
export const SETFLEXIQUOTESUBITEMLISTING = "SETFLEXIQUOTESUBITEMLISTING";
export const SETSALESEMPLOYEELIST = "SETSALESEMPLOYEELIST";
export const SETTERMSANDCONDITION = "SETTERMSANDCONDITION";
export const SETFLEXIFOLLWUPHISTORY = "SETFLEXIFOLLWUPHISTORY";
